'use client';

import styled from 'styled-components';
import { Carousel } from '@mantine/carousel';

import { breakpoints, colors } from '@/styles/theme';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  height: 340px;

  user-select: none;
`;

export const Testimonials = styled(Carousel)`
  width: 1232px;
  margin: 0 auto;

  @media (max-width: ${breakpoints.desktop}) {
    width: 816px;
    left: 50%;
    right: 50%;
    transform: translateX(-50%);
  }

  @media (max-width: ${breakpoints.laptop}) {
    width: 100%;
  }
`;

export const Testimonial = styled.div`
  display: flex;
  width: 400px;
  min-width: 400px;
  min-height: 320px;
  margin: 0 8px;
  padding: 8px;

  @media (max-width: ${breakpoints.laptop}) {
    width: 100%;
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: 320px;
    min-width: 300px;
    max-width: 300px;
  }
`;

export const InnerTestimonial = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  width: 100%;
  min-height: 300px;
  padding: 48px 32px 32px;

  position: relative;

  background: ${colors.white || '#ffffff'};
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 20px;

  /* Premium layered shadow system for authentic depth */
  box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.04),
    0 4px 12px rgba(0, 0, 0, 0.05),
    0 16px 32px rgba(0, 0, 0, 0.04);

  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-4px);
    box-shadow:
      0 2px 4px rgba(0, 0, 0, 0.05),
      0 8px 24px rgba(0, 0, 0, 0.08),
      0 24px 48px rgba(0, 0, 0, 0.06);
    border-color: rgba(0, 0, 0, 0.08);
  }
`;

export const ImageWrap = styled.div`
  width: 72px;
  height: 72px;

  position: absolute;
  top: -36px;
  left: 32px;

  border-radius: 50%;
  overflow: hidden;

  border: 3px solid ${colors.white || '#ffffff'};
  box-shadow:
    0 2px 8px rgba(0, 0, 0, 0.08),
    0 8px 24px rgba(0, 0, 0, 0.06);

  background: ${colors.gray2 || '#f5f5f5'};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const Comment = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;
  color: ${colors.gray8 || '#1a1a1a'};
  letter-spacing: -0.01em;

  margin: 0 0 24px 0;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  line-clamp: 6;
  -webkit-box-orient: vertical;
`;

export const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  padding-top: 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
`;

export const Subject = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
`;

export const StudentName = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${colors.gray9 || '#000000'};
  letter-spacing: -0.02em;
`;

export const EducationLink = styled.div`
  text-align: left;
  font-size: 13px;
  font-weight: 500;
  color: ${colors.gray6 || '#666666'};
  letter-spacing: -0.01em;

  transition: color 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    color: ${colors.gray9 || '#000000'};
  }
`;

export const Score = styled.div`
  display: flex;
  justify-content: flex-end;
`;
